<script>
    let className = "";
    let styleValue = "";
    export {className as class};
    export {styleValue as style};

</script>

<div class="bg-white shadow-md rounded m-4 {className}" style={styleValue}>
    <slot></slot>
</div>